/**
 * Creado por Norte70
 * @author Heriberto Monterrubio <heri185403@gmail.com>
 * @Date 13/01/2021
 */

import * as SessionUtils from '@/core/session_utils.js'

const cart2Request = () => {
    return {
        session_token: SessionUtils.getGuestUserToken(),
        invited: SessionUtils.isGuestUser(),
        cart2: null,
        cart3: null,
        last_dato_solicitante_id: 0
    }
}

export default cart2Request;